import React, { useEffect, useState } from 'react';
import './Dropdown.css';
import LoadingOverlay from '../components/LoadingOverlay';
import PopupImportacaoEmMassa from '../Formulario/PopupImportacaoEmMassa';
import { apiCall } from '../utils/auth';
import { mensagemErroDocumento } from '../utils/validarDocumento';

const UFS = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];

// CEP guardado só com números (8 dígitos) e mostrado como 00000-000, sem cortar número
const somenteDigitosCep = (valor) => String(valor || '').replace(/\D/g, '').slice(0, 8);
const formatarCep = (valor) => {
  const d = somenteDigitosCep(valor);
  return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
};

// Endereço pelo CEP (ViaCEP); null se não encontrar
async function buscarEnderecoPorCep(cep) {
  try {
    const resp = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    const dados = await resp.json();
    if (!resp.ok || dados.erro) return null;
    return { rua: dados.logradouro || '', bairro: dados.bairro || '', cidade: dados.localidade || '', uf: dados.uf || '', regiao: dados.regiao || '' };
  } catch {
    return null;
  }
}

// Helper: listens for MobileFooter generic + event
function MobileAddListener({ onOpen }) {
  useEffect(() => {
    window.addEventListener('open-mobile-add-popup', onOpen);
    return () => window.removeEventListener('open-mobile-add-popup', onOpen);
  }, [onOpen]);
  return null;
}

export default function FornecedorDropdown() {
  const [fornecedores, setFornecedores] = useState([]);
  const [filtradas, setFiltradas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Filtro
  const [filtroCampo, setFiltroCampo] = useState('nome');
  const [filtroValor, setFiltroValor] = useState('');
  const [dropdownAberto, setDropdownAberto] = useState(false);

  // Modal detalhe
  const [detalheAberto, setDetalheAberto] = useState(false);
  const [selecionada, setSelecionada] = useState(null);

  // Modal edição
  const [editarAberto, setEditarAberto] = useState(false);
  const [fornecedorEditando, setFornecedorEditando] = useState(null);
  const [mostrarImportacaoMassa, setMostrarImportacaoMassa] = useState(false);

  // Modal criar
  const [criarAberto, setCriarAberto] = useState(false);
  const [novoFornecedor, setNovoFornecedor] = useState({
    nomeFornecedor: '',
    rua: '',
    bairro: '',
    cidade: '',
    uf: '',
    cep: '',
    regiao: '',
    segmentoUsuarioId: '',
    tipoDocumento: 'CPF',
    cnpj_cpf: '',
    telefoneFornecedor: '',
    emailFornecedor: ''
  });

  // Lista de segmentos
  const [segmentos, setSegmentos] = useState([]);
  
  // Modal para adicionar segmento
  const [adicionarSegmentoAberto, setAdicionarSegmentoAberto] = useState(false);
  const [novoSegmento, setNovoSegmento] = useState('');

  // Campos obrigatórios do formulário (nome + endereço completo)
  const CAMPOS_OBRIGATORIOS = ['nomeFornecedor', 'rua', 'bairro', 'cidade', 'uf', 'cep', 'segmentoUsuarioId'];
  const LABELS_OBRIGATORIOS = {
    nomeFornecedor: 'Nome do Fornecedor',
    rua: 'Endereço (Rua)',
    bairro: 'Bairro',
    cidade: 'Cidade',
    uf: 'UF',
    cep: 'CEP',
    segmentoUsuarioId: 'Segmento'
  };

  const [errosCriar, setErrosCriar] = useState({});
  const [errosEditar, setErrosEditar] = useState({});
  const [erroDocCriar, setErroDocCriar] = useState('');
  const [erroDocEditar, setErroDocEditar] = useState('');

  const validarCamposObrigatorios = (obj) => {
    const erros = {};
    CAMPOS_OBRIGATORIOS.forEach((campo) => {
      if (!obj[campo] || String(obj[campo]).trim() === '') {
        erros[campo] = true;
      }
    });
    return erros;
  };

  const getNomesCamposFaltantes = (erros) =>
    Object.keys(erros)
      .map((campo) => LABELS_OBRIGATORIOS[campo])
      .filter(Boolean);

  useEffect(() => {
    fetchFornecedores();
    fetchSegmentos();
  }, []);

  const fetchFornecedores = async () => {
    try {
      setLoading(true);
      const data = await apiCall('Fornecedor');
      const arr = Array.isArray(data) ? data : [];
      setFornecedores(arr);
      setFiltradas(arr);
      setError('');
    } catch (e) {
      setError('Erro ao carregar fornecedores. Verifique o backend.');
      setFornecedores([]);
      setFiltradas([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchSegmentos = async () => {
    try {
      const data = await apiCall('SegmentoUsuario');
      const arr = Array.isArray(data) ? data : [];
      setSegmentos(arr);
    } catch (e) {
      console.error('Erro ao carregar segmentos:', e);
      setSegmentos([]);
    }
  };

  useEffect(() => {
    if (!filtroValor.trim()) {
      setFiltradas(fornecedores);
      return;
    }
    const val = filtroValor.toLowerCase();
    const f = fornecedores.filter(forn => {
      if (filtroCampo === 'nome') return (forn.nomeFornecedor || '').toLowerCase().includes(val);
      if (filtroCampo === 'cidade') return (forn.cidade || '').toLowerCase().includes(val);
      if (filtroCampo === 'segmento') return (forn.nomeSegmento || '').toLowerCase().includes(val);
      if (filtroCampo === 'cnpj') return (forn.cnpj_CPF || '').toLowerCase().includes(val);
      return true;
    });
    setFiltradas(f);
  }, [filtroValor, filtroCampo, fornecedores]);

  useEffect(() => {
    const handler = () => {
      setDropdownAberto(false);
      setDetalheAberto(false);
      setEditarAberto(false);
      setMostrarImportacaoMassa(false);
      setCriarAberto(false);
      setAdicionarSegmentoAberto(false);
      setSelecionada(null);
      setFornecedorEditando(null);
      setNovoFornecedor({
        nomeFornecedor: '',
        rua: '',
        bairro: '',
        cidade: '',
        uf: '',
        cep: '',
        regiao: '',
        segmentoUsuarioId: '',
        tipoDocumento: 'CPF',
        cnpj_cpf: '',
        telefoneFornecedor: '',
        emailFornecedor: ''
      });
      setErroDocCriar('');
      setErroDocEditar('');
    };
    window.addEventListener('fornecedores-fechar-todos-popups', handler);
    return () => window.removeEventListener('fornecedores-fechar-todos-popups', handler);
  }, []);

  const abrirDetalhe = (f) => {
    setSelecionada(f);
    setDetalheAberto(true);
  };

  const abrirEditar = (f) => {
    const digitos = (f.cnpj_CPF || '').replace(/\D/g, '');
    setFornecedorEditando({ ...f, tipoDocumento: digitos.length === 14 ? 'CNPJ' : 'CPF' });
    setErroDocEditar('');
    setEditarAberto(true);
  };

  const handleSalvarEdicao = async () => {
    const erros = validarCamposObrigatorios(fornecedorEditando);
    setErrosEditar(erros);
    const erroDoc = fornecedorEditando.cnpj_CPF ? mensagemErroDocumento(fornecedorEditando.cnpj_CPF, fornecedorEditando.tipoDocumento) : `${fornecedorEditando.tipoDocumento} é obrigatório`;
    setErroDocEditar(erroDoc);
    if (Object.keys(erros).length > 0) {
      const faltantes = getNomesCamposFaltantes(erros).join(', ');
      alert(`Preencha os campos obrigatórios: ${faltantes}`);
      return;
    }
    if (erroDoc) {
      return;
    }
    try {
      setLoading(true);
      const { tipoUsuarioId: _tipoUsuario, tipoUsuarioDescricao: _tipoDescricao, ...dadosEdicao } = fornecedorEditando;
      await apiCall(`Fornecedor/${fornecedorEditando.id}`, 'PUT', dadosEdicao);
      alert('Fornecedor atualizado com sucesso!');
      setEditarAberto(false);
      setErrosEditar({});
      setErroDocEditar('');
      fetchFornecedores();
    } catch (error) {
      alert('Erro ao atualizar fornecedor');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCriarFornecedor = async () => {
    const erros = validarCamposObrigatorios(novoFornecedor);
    setErrosCriar(erros);
    const erroDoc = novoFornecedor.cnpj_cpf ? mensagemErroDocumento(novoFornecedor.cnpj_cpf, novoFornecedor.tipoDocumento) : `${novoFornecedor.tipoDocumento} é obrigatório`;
    setErroDocCriar(erroDoc);
    if (Object.keys(erros).length > 0) {
      const faltantes = getNomesCamposFaltantes(erros).join(', ');
      alert(`Preencha os campos obrigatórios: ${faltantes}`);
      return;
    }
    if (erroDoc) {
      return;
    }

    try {
      const payload = {
        id: 0,
        nomeFornecedor: novoFornecedor.nomeFornecedor,
        rua: novoFornecedor.rua || null,
        bairro: novoFornecedor.bairro || null,
        cidade: novoFornecedor.cidade || null,
        uf: novoFornecedor.uf || null,
        cep: novoFornecedor.cep || null,
        regiao: novoFornecedor.regiao || null,
        segmentoUsuarioId: novoFornecedor.segmentoUsuarioId ? parseInt(novoFornecedor.segmentoUsuarioId) : null,
        cnpj_CPF: novoFornecedor.cnpj_cpf || null,
        telefoneFornecedor: novoFornecedor.telefoneFornecedor || null,
        emailFornecedor: novoFornecedor.emailFornecedor || null
      };

      await apiCall('Fornecedor', 'POST', payload);
      alert('Fornecedor criado com sucesso!');
      setCriarAberto(false);
      setErrosCriar({});
      setErroDocCriar('');
      setNovoFornecedor({
        nomeFornecedor: '',
        rua: '',
        bairro: '',
        cidade: '',
        uf: '',
        cep: '',
        regiao: '',
        segmentoUsuarioId: '',
        tipoDocumento: 'CPF',
        cnpj_cpf: '',
        telefoneFornecedor: '',
        emailFornecedor: ''
      });
      fetchFornecedores();
    } catch (error) {
      alert('Erro ao criar fornecedor');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdicionarSegmento = async () => {
    try {
      if (!novoSegmento.trim()) {
        alert('Digite um nome para o segmento');
        return;
      }
      
      const payload = {
        id: 0,
        nomeSegmento: novoSegmento
      };

      await apiCall('SegmentoUsuario', 'POST', payload);
      alert('Segmento adicionado com sucesso!');
      setNovoSegmento('');
      setAdicionarSegmentoAberto(false);
      fetchSegmentos(); // Recarrega a lista de segmentos
    } catch (error) {
      alert('Erro ao adicionar segmento');
      console.error(error);
    }
  };

  const Campo = ({ label, value }) => (
    <div style={{ display: 'flex', flexDirection: 'column', minWidth: 120 }}>
      <label style={{ fontWeight: 600, marginBottom: 4, fontSize: 12, color: '#666' }}>{label}</label>
      <span style={{ fontSize: 14 }}>{value ?? '—'}</span>
    </div>
  );

  return (
    <div className="container-geral fundo-branco" style={{ minHeight: 'calc(100vh - var(--global-header-height, 64px))', background: '#f0f0f0', padding: 20 }}>
      <h2 style={{ textAlign: 'center', color: '#2196F3', marginBottom: 20 }}>🏭 Fornecedores</h2>

      <MobileAddListener onOpen={() => setCriarAberto(true)} />

      {/* Ações */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'center', marginBottom: '20px' }}>
        <button 
          className="btn-adicionar-fornecedor"
          onClick={() => setCriarAberto(true)}
          style={{ 
            padding: '12px 24px', 
            backgroundColor: 'rgb(235, 133, 0)', 
            color: 'white', 
            border: 'none', 
            borderRadius: 6, 
            cursor: 'pointer', 
            fontWeight: 600,
            fontSize: '16px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
          }}
        >
          + Adicionar
        </button>
        <button
          onClick={() => setMostrarImportacaoMassa(true)}
          style={{ padding: '12px 24px', backgroundColor: '#2e7d32', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: '16px', boxShadow: '0 2px 6px rgba(0,0,0,0.15)' }}
        >
          Cadastro em Massa
        </button>
      </div>

      {/* Card de Estatísticas */}
      <div className="fornecedor-estatisticas" style={{ 
        backgroundColor: '#fff', 
        padding: '20px', 
        borderRadius: '10px', 
        marginBottom: '20px', 
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>Total de Fornecedores</div>
          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#2196F3' }}>{filtradas.length}</div>
        </div>
      </div>

      {/* Filtro */}
      <div className="filtro-container">
        <div className="filtro-wrapper">
          <input
            type="text"
            placeholder={`Filtrar por ${
              filtroCampo === 'nome' ? 'Nome' :
              filtroCampo === 'cidade' ? 'Cidade' :
              filtroCampo === 'segmento' ? 'Segmento' :
              filtroCampo === 'cnpj' ? 'CNPJ/CPF' : '—'
            }...`}
            value={filtroValor}
            onChange={(e) => setFiltroValor(e.target.value)}
            className="filtro-input"
          />
          <div className="dropdown-wrapper">
            <button className="dropdown-button" onClick={() => setDropdownAberto(!dropdownAberto)}>
              {filtroCampo === 'nome' ? 'Nome' :
               filtroCampo === 'cidade' ? 'Cidade' :
               filtroCampo === 'segmento' ? 'Segmento' :
               filtroCampo === 'cnpj' ? 'CNPJ/CPF' : 'Filtrar por'}
              <span className="dropdown-arrow">▼</span>
            </button>
            {dropdownAberto && (
              <div className="dropdown-menu">
                <div className="dropdown-item" onClick={() => { setFiltroCampo('nome'); setDropdownAberto(false); }}>Nome</div>
                <div className="dropdown-item" onClick={() => { setFiltroCampo('cidade'); setDropdownAberto(false); }}>Cidade</div>
                <div className="dropdown-item" onClick={() => { setFiltroCampo('segmento'); setDropdownAberto(false); }}>Segmento</div>
                <div className="dropdown-item" onClick={() => { setFiltroCampo('cnpj'); setDropdownAberto(false); }}>CNPJ/CPF</div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Estados */}
      {loading && (<div style={{ textAlign: 'center', padding: 40, color: '#666' }}>Carregando fornecedores...</div>)}
      {error && (
        <div style={{ textAlign: 'center', padding: 20, color: '#b00020', background: '#fdecea', borderRadius: 6, margin: '20px 0' }}>{error}</div>
      )}

      {/* Lista */}
      {!loading && !error && (
        <div className="fornecedor-cards-container">
          {(!filtradas || filtradas.length === 0) ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#666', background: 'white', marginTop: 10 }}>
              {filtroValor ? 'Nenhum fornecedor encontrado para o filtro' : 'Nenhum fornecedor cadastrado'}
            </div>
          ) : (
            filtradas.map((f, idx) => {
              return (
                <div className="fornecedor-card" key={f.id || idx}>
                  <div className="fornecedor-card-content">
                    <div className="fornecedor-card-fields">
                      <div className="fornecedor-field fornecedor-field-id">
                        <span className="fornecedor-field-label">ID:</span>
                        <span className="fornecedor-field-value">{f.id}</span>
                      </div>
                      <div className="fornecedor-field fornecedor-field-nome">
                        <span className="fornecedor-field-label">Nome:</span>
                        <span className="fornecedor-field-value">{f.nomeFornecedor}</span>
                      </div>
                      <div className="fornecedor-field fornecedor-field-cnpj">
                        <span className="fornecedor-field-label">CNPJ/CPF:</span>
                        <span className="fornecedor-field-value">{f.cnpj_CPF}</span>
                      </div>
                      <div className="fornecedor-field fornecedor-field-telefone">
                        <span className="fornecedor-field-label">Telefone:</span>
                        <span className="fornecedor-field-value">{f.telefoneFornecedor}</span>
                      </div>
                      <div className="fornecedor-field fornecedor-field-email">
                        <span className="fornecedor-field-label">Email:</span>
                        <span className="fornecedor-field-value">{f.emailFornecedor}</span>
                      </div>
                      <div className="fornecedor-field fornecedor-field-cidade">
                        <span className="fornecedor-field-label">Cidade:</span>
                        <span className="fornecedor-field-value">{f.cidade}</span>
                      </div>
                      <div className="fornecedor-field fornecedor-field-uf">
                        <span className="fornecedor-field-label">UF:</span>
                        <span className="fornecedor-field-value">{f.uf}</span>
                      </div>
                      <div className="fornecedor-field fornecedor-field-segmento">
                        <span className="fornecedor-field-label">Segmento:</span>
                        <span className="fornecedor-field-value">{f.nomeSegmento}</span>
                      </div>
                    </div>
                  </div>
                  <div className="fornecedor-card-actions">
                    <button className="btn-detalhe-fornecedor" onClick={() => abrirDetalhe(f)} title="Ver detalhes">Ver Detalhes</button>
                    <button className="btn-editar-fornecedor" onClick={() => abrirEditar(f)} title="Editar">Editar</button>
                  </div>
                </div>
              );
            })
          )}
        </div>
      )}

      {/* Modal Detalhe */}
      {detalheAberto && selecionada && (
        <div className="modal-overlay" onClick={() => setDetalheAberto(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: '92%', maxWidth: 800, background: '#fff', borderRadius: 12, padding: 20, maxHeight: '85vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h3 style={{ margin: 0, color: '#2196F3' }}>🏭 Fornecedor - Detalhes</h3>
              <button onClick={() => setDetalheAberto(false)} aria-label="Fechar" title="Fechar" style={{ backgroundColor: '#2196F3', color: '#fff', border: 'none', borderRadius: '50%', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, cursor: 'pointer', boxShadow: '0 2px 6px rgba(0,0,0,0.15)' }}>×</button>
            </div>
            <div className="formulario-fornecedor-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              {[
                ['ID', selecionada.id],
                ['Nome', selecionada.nomeFornecedor],
                ['CNPJ/CPF', selecionada.cnpj_CPF],
                ['Telefone', selecionada.telefoneFornecedor],
                ['Email', selecionada.emailFornecedor],
                ['Rua', selecionada.rua],
                ['Bairro', selecionada.bairro],
                ['Cidade', selecionada.cidade],
                ['UF', selecionada.uf],
                ['CEP', formatarCep(selecionada.cep)],
                ['Região', selecionada.regiao],
                ['Segmento', selecionada.nomeSegmento],
              ].map(([label, value], i) => (
                <div key={i} style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>{label}</label>
                  <input type="text" readOnly value={value ?? ''} style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd', background: '#f5f5f5' }} />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar */}
      {editarAberto && fornecedorEditando && (
        <div className="modal-overlay" onClick={() => setEditarAberto(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: '92%', maxWidth: 800, background: '#fff', borderRadius: 12, padding: 20, maxHeight: '85vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h3 style={{ margin: 0, color: '#2196F3' }}>✏️ Editar Fornecedor</h3>
              <button onClick={() => setEditarAberto(false)} aria-label="Fechar" title="Fechar" style={{ backgroundColor: '#2196F3', color: '#fff', border: 'none', borderRadius: '50%', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, cursor: 'pointer' }}>×</button>
            </div>
            <div className="formulario-fornecedor-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Nome do Fornecedor *</label>
                <input
                  type="text"
                  value={fornecedorEditando.nomeFornecedor || ''}
                  onChange={(e) => setFornecedorEditando({ ...fornecedorEditando, nomeFornecedor: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosEditar.nomeFornecedor ? '#f44336' : '#ddd'}` }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Tipo de Documento</label>
                <div style={{ display: 'flex', gap: 16, alignItems: 'center', height: 38 }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 14 }}>
                    <input
                      type="radio"
                      name="tipoDocumentoEditar"
                      checked={fornecedorEditando.tipoDocumento !== 'CNPJ'}
                      onChange={() => setFornecedorEditando({ ...fornecedorEditando, tipoDocumento: 'CPF', cnpj_CPF: (fornecedorEditando.cnpj_CPF || '').replace(/\D/g, '').slice(0, 11) })}
                    />
                    CPF
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 14 }}>
                    <input
                      type="radio"
                      name="tipoDocumentoEditar"
                      checked={fornecedorEditando.tipoDocumento === 'CNPJ'}
                      onChange={() => setFornecedorEditando({ ...fornecedorEditando, tipoDocumento: 'CNPJ' })}
                    />
                    CNPJ
                  </label>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>{fornecedorEditando.tipoDocumento === 'CNPJ' ? 'CNPJ' : 'CPF'} *</label>
                <input
                  type="text"
                  value={fornecedorEditando.cnpj_CPF || ''}
                  onChange={(e) => {
                    const maxLen = fornecedorEditando.tipoDocumento === 'CNPJ' ? 14 : 11;
                    const apenasNumeros = e.target.value.replace(/\D/g, '').slice(0, maxLen);
                    setFornecedorEditando({ ...fornecedorEditando, cnpj_CPF: apenasNumeros });
                    setErroDocEditar(mensagemErroDocumento(apenasNumeros, fornecedorEditando.tipoDocumento));
                  }}
                  onBlur={(e) => setErroDocEditar(mensagemErroDocumento(e.target.value, fornecedorEditando.tipoDocumento))}
                  maxLength={fornecedorEditando.tipoDocumento === 'CNPJ' ? 14 : 11}
                  placeholder={fornecedorEditando.tipoDocumento === 'CNPJ' ? 'Somente números (14 dígitos)' : 'Somente números (11 dígitos)'}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${erroDocEditar ? '#f44336' : '#ddd'}` }}
                />
                {erroDocEditar && <span style={{ color: '#f44336', fontSize: 12, marginTop: 4 }}>{erroDocEditar}</span>}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Telefone</label>
                <input
                  type="text"
                  value={fornecedorEditando.telefoneFornecedor || ''}
                  onChange={(e) => setFornecedorEditando({ ...fornecedorEditando, telefoneFornecedor: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Email</label>
                <input
                  type="email"
                  value={fornecedorEditando.emailFornecedor || ''}
                  onChange={(e) => setFornecedorEditando({ ...fornecedorEditando, emailFornecedor: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>CEP *</label>
                <input
                  type="text"
                  inputMode="numeric"
                  value={formatarCep(fornecedorEditando.cep)}
                  maxLength={9}
                  onChange={async (e) => {
                    const cep = somenteDigitosCep(e.target.value);
                    setFornecedorEditando(prev => ({ ...prev, cep }));
                    if (cep.length === 8) {
                      const endereco = await buscarEnderecoPorCep(cep);
                      if (endereco) {
                        setFornecedorEditando(prev => ({
                          ...prev,
                          rua: endereco.rua || prev.rua,
                          bairro: endereco.bairro || prev.bairro,
                          cidade: endereco.cidade || prev.cidade,
                          uf: endereco.uf || prev.uf,
                          regiao: endereco.regiao || prev.regiao
                        }));
                      }
                    }
                  }}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosEditar.cep ? '#f44336' : '#ddd'}` }}
                  placeholder="00000-000"
                />
                <small style={{ color: '#888', fontSize: 11, marginTop: 4 }}>Digite o CEP para preencher o endereço automaticamente</small>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Rua *</label>
                <input
                  type="text"
                  value={fornecedorEditando.rua || ''}
                  onChange={(e) => setFornecedorEditando({ ...fornecedorEditando, rua: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosEditar.rua ? '#f44336' : '#ddd'}` }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Bairro *</label>
                <input
                  type="text"
                  value={fornecedorEditando.bairro || ''}
                  onChange={(e) => setFornecedorEditando({ ...fornecedorEditando, bairro: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosEditar.bairro ? '#f44336' : '#ddd'}` }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Cidade *</label>
                <input
                  type="text"
                  value={fornecedorEditando.cidade || ''}
                  onChange={(e) => setFornecedorEditando({ ...fornecedorEditando, cidade: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosEditar.cidade ? '#f44336' : '#ddd'}` }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>UF *</label>
                <select
                  value={fornecedorEditando.uf || ''}
                  onChange={(e) => setFornecedorEditando({ ...fornecedorEditando, uf: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosEditar.uf ? '#f44336' : '#ddd'}`, background: '#fff' }}
                >
                  <option value="">Selecione...</option>
                  {UFS.map(uf => <option key={uf} value={uf}>{uf}</option>)}
                </select>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Região</label>
                <input
                  type="text"
                  value={fornecedorEditando.regiao || ''}
                  onChange={(e) => setFornecedorEditando({ ...fornecedorEditando, regiao: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Segmento *</label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <select
                    value={fornecedorEditando.segmentoUsuarioId || ''}
                    onChange={(e) => setFornecedorEditando({ ...fornecedorEditando, segmentoUsuarioId: e.target.value })}
                    style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosEditar.segmentoUsuarioId ? '#f44336' : '#ddd'}`, flex: 1 }}
                  >
                    <option value="">Selecione...</option>
                    {segmentos.map((seg) => (
                      <option key={seg.id} value={seg.id}>{seg.nomeSegmento}</option>
                    ))}
                  </select>
                  <button
                    onClick={() => setAdicionarSegmentoAberto(true)}
                    type="button"
                    style={{ padding: '10px 15px', backgroundColor: 'rgb(235, 133, 0)', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' }}
                    title="Adicionar novo segmento"
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
            <div className="form-buttons-container-fornecedor" style={{ marginTop: 20, display: 'flex', gap: 10, justifyContent: 'center' }}>
              <button
                onClick={handleSalvarEdicao}
                className="btn-salvar-fornecedor"
                style={{ padding: '12px 30px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
              >
                Salvar
              </button>
              <button
                onClick={() => setEditarAberto(false)}
                className="btn-cancelar-fornecedor"
                style={{ padding: '12px 30px', backgroundColor: '#f44336', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Criar */}
      {criarAberto && (
        <div className="modal-overlay" onClick={() => setCriarAberto(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: '92%', maxWidth: 800, background: '#fff', borderRadius: 12, padding: 20, maxHeight: '85vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h3 style={{ margin: 0, color: 'rgb(235, 133, 0)' }}>Adicionar Fornecedor</h3>
              <button onClick={() => setCriarAberto(false)} aria-label="Fechar" title="Fechar" style={{ backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: '50%', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, cursor: 'pointer' }}>×</button>
            </div>
            <div className="formulario-fornecedor-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Nome do Fornecedor *</label>
                <input
                  type="text"
                  value={novoFornecedor.nomeFornecedor}
                  onChange={(e) => setNovoFornecedor({ ...novoFornecedor, nomeFornecedor: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosCriar.nomeFornecedor ? '#f44336' : '#ddd'}` }}
                  placeholder="Nome do fornecedor"
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Tipo de Documento</label>
                <div style={{ display: 'flex', gap: 16, alignItems: 'center', height: 38 }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 14 }}>
                    <input
                      type="radio"
                      name="tipoDocumentoCriar"
                      checked={novoFornecedor.tipoDocumento !== 'CNPJ'}
                      onChange={() => setNovoFornecedor({ ...novoFornecedor, tipoDocumento: 'CPF', cnpj_cpf: novoFornecedor.cnpj_cpf.slice(0, 11) })}
                    />
                    CPF
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 14 }}>
                    <input
                      type="radio"
                      name="tipoDocumentoCriar"
                      checked={novoFornecedor.tipoDocumento === 'CNPJ'}
                      onChange={() => setNovoFornecedor({ ...novoFornecedor, tipoDocumento: 'CNPJ' })}
                    />
                    CNPJ
                  </label>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>{novoFornecedor.tipoDocumento === 'CNPJ' ? 'CNPJ' : 'CPF'} *</label>
                <input
                  type="text"
                  value={novoFornecedor.cnpj_cpf}
                  onChange={(e) => {
                    const maxLen = novoFornecedor.tipoDocumento === 'CNPJ' ? 14 : 11;
                    const apenasNumeros = e.target.value.replace(/\D/g, '').slice(0, maxLen);
                    setNovoFornecedor({ ...novoFornecedor, cnpj_cpf: apenasNumeros });
                    setErroDocCriar(mensagemErroDocumento(apenasNumeros, novoFornecedor.tipoDocumento));
                  }}
                  onBlur={(e) => setErroDocCriar(mensagemErroDocumento(e.target.value, novoFornecedor.tipoDocumento))}
                  maxLength={novoFornecedor.tipoDocumento === 'CNPJ' ? 14 : 11}
                  placeholder={novoFornecedor.tipoDocumento === 'CNPJ' ? 'Somente números (14 dígitos)' : 'Somente números (11 dígitos)'}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${erroDocCriar ? '#f44336' : '#ddd'}` }}
                />
                {erroDocCriar && <span style={{ color: '#f44336', fontSize: 12, marginTop: 4 }}>{erroDocCriar}</span>}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Telefone</label>
                <input
                  type="text"
                  value={novoFornecedor.telefoneFornecedor}
                  onChange={(e) => setNovoFornecedor({ ...novoFornecedor, telefoneFornecedor: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }}
                  placeholder="(00) 00000-0000"
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Email</label>
                <input
                  type="email"
                  value={novoFornecedor.emailFornecedor}
                  onChange={(e) => setNovoFornecedor({ ...novoFornecedor, emailFornecedor: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }}
                  placeholder="email@exemplo.com"
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>CEP *</label>
                <input
                  type="text"
                  inputMode="numeric"
                  value={formatarCep(novoFornecedor.cep)}
                  maxLength={9}
                  onChange={async (e) => {
                    const cep = somenteDigitosCep(e.target.value);
                    setNovoFornecedor(prev => ({ ...prev, cep }));
                    if (cep.length === 8) {
                      const endereco = await buscarEnderecoPorCep(cep);
                      if (endereco) {
                        setNovoFornecedor(prev => ({
                          ...prev,
                          rua: endereco.rua || prev.rua,
                          bairro: endereco.bairro || prev.bairro,
                          cidade: endereco.cidade || prev.cidade,
                          uf: endereco.uf || prev.uf,
                          regiao: endereco.regiao || prev.regiao
                        }));
                      }
                    }
                  }}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosCriar.cep ? '#f44336' : '#ddd'}` }}
                  placeholder="00000-000"
                />
                <small style={{ color: '#888', fontSize: 11, marginTop: 4 }}>Digite o CEP para preencher o endereço automaticamente</small>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Rua *</label>
                <input
                  type="text"
                  value={novoFornecedor.rua}
                  onChange={(e) => setNovoFornecedor({ ...novoFornecedor, rua: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosCriar.rua ? '#f44336' : '#ddd'}` }}
                  placeholder="Nome da rua"
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Bairro *</label>
                <input
                  type="text"
                  value={novoFornecedor.bairro}
                  onChange={(e) => setNovoFornecedor({ ...novoFornecedor, bairro: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosCriar.bairro ? '#f44336' : '#ddd'}` }}
                  placeholder="Nome do bairro"
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Cidade *</label>
                <input
                  type="text"
                  value={novoFornecedor.cidade}
                  onChange={(e) => setNovoFornecedor({ ...novoFornecedor, cidade: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosCriar.cidade ? '#f44336' : '#ddd'}` }}
                  placeholder="Nome da cidade"
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>UF *</label>
                <select
                  value={novoFornecedor.uf || ''}
                  onChange={(e) => setNovoFornecedor({ ...novoFornecedor, uf: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosCriar.uf ? '#f44336' : '#ddd'}`, background: '#fff' }}
                >
                  <option value="">Selecione...</option>
                  {UFS.map(uf => <option key={uf} value={uf}>{uf}</option>)}
                </select>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Região</label>
                <input
                  type="text"
                  value={novoFornecedor.regiao}
                  onChange={(e) => setNovoFornecedor({ ...novoFornecedor, regiao: e.target.value })}
                  style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }}
                  placeholder="Ex: Sudeste"
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Segmento *</label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <select
                    value={novoFornecedor.segmentoUsuarioId || ''}
                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, segmentoUsuarioId: e.target.value })}
                    style={{ padding: '10px', borderRadius: 6, border: `1px solid ${errosCriar.segmentoUsuarioId ? '#f44336' : '#ddd'}`, flex: 1 }}
                  >
                    <option value="">Selecione...</option>
                    {segmentos.map((seg) => (
                      <option key={seg.id} value={seg.id}>{seg.nomeSegmento}</option>
                    ))}
                  </select>
                  <button
                    onClick={() => setAdicionarSegmentoAberto(true)}
                    type="button"
                    style={{ 
                      padding: '10px 15px', 
                      backgroundColor: 'rgb(235, 133, 0)', 
                      color: 'white', 
                      border: 'none', 
                      borderRadius: 6, 
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      fontSize: '16px'
                    }}
                    title="Adicionar novo segmento"
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
            <div className="form-buttons-container-fornecedor" style={{ marginTop: 20, display: 'flex', gap: 10, justifyContent: 'center' }}>
              <button
                onClick={handleCriarFornecedor}
                className="btn-salvar-fornecedor"
                style={{ padding: '12px 30px', backgroundColor: 'rgb(235, 133, 0)', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
              >
                Adicionar
              </button>
              <button
                onClick={() => setCriarAberto(false)}
                className="btn-cancelar-fornecedor"
                style={{ padding: '12px 30px', backgroundColor: '#f44336', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Adicionar Segmento */}
      {adicionarSegmentoAberto && (
        <div className="modal-overlay" onClick={() => setAdicionarSegmentoAberto(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: '90%', maxWidth: 400, background: '#fff', borderRadius: 12, padding: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h3 style={{ margin: 0, color: 'rgb(235, 133, 0)' }}>Adicionar Segmento</h3>
              <button onClick={() => setAdicionarSegmentoAberto(false)} style={{ backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: '50%', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, cursor: 'pointer' }}>×</button>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600, display: 'block' }}>Descrição do Segmento</label>
              <input
                type="text"
                value={novoSegmento}
                onChange={(e) => setNovoSegmento(e.target.value)}
                style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd', width: '100%' }}
                placeholder="Ex: Eletrônicos, Materiais..."
                onKeyPress={(e) => e.key === 'Enter' && handleAdicionarSegmento()}
              />
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
              <button
                onClick={handleAdicionarSegmento}
                style={{ padding: '10px 20px', backgroundColor: 'rgb(235, 133, 0)', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
              >
                Adicionar
              </button>
              <button
                onClick={() => setAdicionarSegmentoAberto(false)}
                style={{ padding: '10px 20px', backgroundColor: '#999', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}


      {mostrarImportacaoMassa && (
        <PopupImportacaoEmMassa
          titulo="Fornecedores"
          nomeArquivo="template_importacao_fornecedores"
          nomeAba="Fornecedores"
          colunas={['NomeFornecedor', 'CNPJ_CPF', 'TelefoneFornecedor', 'EmailFornecedor', 'Rua', 'Bairro', 'Cidade', 'UF', 'CEP', 'Regiao', 'SegmentoUsuarioId', 'TipoFornecedorId']}
          camposObrigatorios={['NomeFornecedor', 'CNPJ_CPF', 'Rua', 'Bairro', 'Cidade', 'UF', 'CEP']}
          exemplos={[{ NomeFornecedor: 'Fornecedor Exemplo LTDA', CNPJ_CPF: '12345678000190', TelefoneFornecedor: '11999998888', EmailFornecedor: 'contato@fornecedor.com', Rua: 'Rua das Flores', Bairro: 'Centro', Cidade: 'Sao Paulo', UF: 'SP', CEP: '01234567', Regiao: '', SegmentoUsuarioId: '', TipoFornecedorId: '' }]}
          instrucoes={['Preencha uma linha para cada fornecedor.', 'CNPJ_CPF deve conter somente CPF ou CNPJ.', 'SegmentoUsuarioId e TipoFornecedorId são opcionais e devem ser IDs já cadastrados.']}
          endpoint="Fornecedor"
          criarPayload={(linha) => ({
            nomeFornecedor: String(linha.NomeFornecedor).trim(),
            cnpj_CPF: String(linha.CNPJ_CPF).replace(/\D/g, ''),
            telefoneFornecedor: String(linha.TelefoneFornecedor || '').trim(),
            emailFornecedor: String(linha.EmailFornecedor || '').trim(),
            rua: String(linha.Rua).trim(),
            bairro: String(linha.Bairro).trim(),
            cidade: String(linha.Cidade).trim(),
            uf: String(linha.UF).trim().toUpperCase(),
            cep: String(linha.CEP).replace(/\D/g, ''),
            regiao: String(linha.Regiao || '').trim(),
            segmentoUsuarioId: linha.SegmentoUsuarioId === '' ? null : Number(linha.SegmentoUsuarioId),
            tipoFornecedorId: linha.TipoFornecedorId === '' ? null : Number(linha.TipoFornecedorId)
          })}
          onFechar={() => setMostrarImportacaoMassa(false)}
          onSucesso={fetchFornecedores}
        />
      )}

      <LoadingOverlay isLoading={loading} message="Processando..." />
    </div>
  );
}
